import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { GameService } from '../../services/game.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-game-list-modal',
  templateUrl: './game-list-modal.component.html',
  styleUrls: ['./game-list-modal.component.scss']
})
export class GameListModalComponent implements OnInit {

  games: GameStub[] = [];
  err: string = "";
  default_team_avatar: string = 'https://ktteamimages.s3.us-west-2.amazonaws.com/TeamIcon.png'

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {modalClose: any, gameStubs: GameStub[]},
    private gameService: GameService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.games = this.data.gameStubs;
  }

  joinExisting(game: any): void {
    // redirect to the game if watching/spectator
    if( game?.spectator === true ){
      this.router.navigate(['/game', game?.gameid]);
      return;
    }
    
    this.err = ""
    this.gameService.joinGameById(game.gameid)
    .subscribe(
      joinResult => {
        this.router.navigate(['game', joinResult.game_id]);
        this.data.modalClose();
      },
      err => {
        if (err.error.status_code === 401) {
          localStorage.removeItem("auth_token");
          this.router.navigate(['/auth']);
        }
        else this.err = err.error.detail
      });
  }

}
